export const listAccounts = `
   query listAccounts($filter: AccountsFilterInput, $limit: Int, $nextToken: String) {
       listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              sub
              username
              email
              accountType
              accountStatus
              customerId
              created
              updated
           }
           nextToken
       }
   }
`;

export const listAccountsWithPagination = `
       listAccounts {
           items {
              id
              sub
              username
              email
              accountType
              accountStatus
              customerId
           }
       }
   }
`;

export const getAccount = `
   query getAccount($id: ID!) {
       getAccount(id: $id) {
         id
         sub
         username
         email
         accountType
         accountStatus
         customerId
         created
         updated
       } 
   }
`;
